import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Persist a ?ref=CODE referral code from any page so it survives site browsing.
export default function RefCapture() {
  const location = useLocation();
  useEffect(() => {
    const ref = new URLSearchParams(location.search).get("ref");
    if (ref) localStorage.setItem("afha_ref", ref.trim().toUpperCase());
  }, [location.search]);
  return null;
}
